// Configuration for the frontend application
const config = {
  // API URL - change this based on environment
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  
  // Add other configuration variables as needed
};

// Check if we're in production based on either NODE_ENV or the current hostname
const isProduction = process.env.NODE_ENV === 'production' || 
                    window.location.hostname === 'in030.com' || 
                    window.location.hostname === 'www1.in030.com';

// Override for production environment
if (isProduction) {
  // Use HTTPS for the API URL in production
  // Use the same domain as the frontend to avoid CORS issues
  config.apiUrl = process.env.REACT_APP_API_URL || `${window.location.protocol}//${window.location.hostname}/api`;
  console.log('Using production API URL:', config.apiUrl);
}

// Log the current API URL for debugging
console.log('Current API URL:', config.apiUrl);
console.log('Current environment:', process.env.NODE_ENV);
console.log('Current hostname:', window.location.hostname);

export default config; 